import { apiClient, ADMIN_URL } from 'src/app/common/network';

export const getEventList = async (params?: any) => {
  return apiClient.get(`${ADMIN_URL}/events`, { params });
};
